<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">

      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->
      <img :src="logo" alt="logo" style="width:200px;height:63px;">
      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->

      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
  import { mixin } from '@/utils/mixin.js'
  import {TENANT_ID} from "@/store/mutation-types";
  import Vue from "vue";
  import {getAction} from "@api/manage";

  export default {
    name: 'Logo',
    mixins: [mixin],
    props: {
      title: {
        type: String,
        default: '',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    data() {
      return {
        logo: ""
      }
    },
    created() {
      var tenantId = Number(Vue.ls.get(TENANT_ID));
      getAction("/sys/tenant/queryById",{"id": tenantId}).then(res => {
        if(res.code === 0){
          this.logo = window._CONFIG['staticDomainURL'] + res.result.pic
        }
      })
    }
  }
</script>
<style lang="less" scoped>
  /*缩小首页布 局顶部的高度*/
  @height: 59px;

  .sider {
    box-shadow: none !important;
    .logo {
      height: @height !important;
      line-height: @height !important;
      box-shadow: none !important;
      transition: background 300ms;

      a {
        margin-left: -24px;
        color: white;
        width: 100px;
        height: 100px;
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    &.light .logo {
      background-color: @primary-color;
    }
  }
</style>